import { useState, useLayoutEffect } from "react"
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service"
import { Table, Spin } from "antd"
import { CSVLink } from "react-csv"
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service"

const emptySummary = { orders: 0, customers: 0, owed: 0, paid: 0, net: 0 }
const money = (value) => new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(value || 0)

const ReportDebtCollection = () => {
    const today = format(new Date(), "yyyy-MM-dd")
    const [startDate, setStartDate] = useState(format(startOfMonth(new Date()), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(today)
    const [store, setStore] = useState(0)
    const [details, setDetails] = useState([])
    const [summary, setSummary] = useState(emptySummary)
    const [loading, setLoading] = useState(false)
    const [userAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))

    const fetchData = async () => {
        setLoading(true)
        const res = await axiosService("api/reports/debt-collection", "POST", { store, startDate, endDate })
        if (res?.data?.code === 200) {
            setSummary(res.data.data?.summary || emptySummary)
            setDetails((res.data.data?.details || []).map((item) => ({ ...item, key: item.id })))
        } else {
            setSummary(emptySummary)
            setDetails([])
        }
        setLoading(false)
    }

    useLayoutEffect(() => {
        fetchData()
    }, [startDate, endDate, store])

    const columns = [
        {
            title: "Ngày mua dịch vụ",
            dataIndex: "order_at",
            width: 150,
            render: (v) => v ? format(new Date(v), "dd-MM-yyyy HH:mm") : "",
        },
        {
            title: "Tên KH / SĐT",
            width: 200,
            render: (_, r) => (
                <div>
                    <div>{r.full_name}</div>
                    <div style={{ color: "#666" }}>{r.mobile}</div>
                </div>
            ),
        },
        { title: "Thẻ dịch vụ mua", dataIndex: "cards", width: 240, ellipsis: true },
        { title: "Doanh số thuần", dataIndex: "net_sales", align: "right", width: 140, render: money },
        {
            title: "Thực thu",
            dataIndex: "paid",
            align: "right",
            width: 160,
            render: (v, r) => (
                <div>
                    <div>{money(v)}</div>
                    <div style={{ color: "#666", fontSize: 12 }}>{r.pay_count} lần thanh toán</div>
                </div>
            ),
        },
        { title: "Chưa thanh toán", dataIndex: "owed", align: "right", width: 140, render: money },
        { title: "Nhân sự tư vấn", dataIndex: "consultants", width: 180, ellipsis: true },
        { title: "Cơ sở", dataIndex: "store_name", width: 160, ellipsis: true },
    ]

    const csvData = details.map((r) => ({
        "Ngày mua dịch vụ": r.order_at ? format(new Date(r.order_at), "dd-MM-yyyy HH:mm") : "",
        "Tên KH": r.full_name,
        "SĐT": r.mobile,
        "Thẻ dịch vụ mua": r.cards,
        "Doanh số thuần": Math.round(r.net_sales),
        "Thực thu": Math.round(r.paid),
        "Số lần thanh toán": r.pay_count,
        "Chưa thanh toán": Math.round(r.owed),
        "Nhân sự tư vấn": r.consultants,
        "Cơ sở": r.store_name,
    }))

    const metrics = [
        ["Tổng chưa thanh toán", money(summary.owed)],
        ["Số đơn còn nợ", summary.orders],
        ["Số khách hàng", summary.customers],
        ["Doanh số thuần", money(summary.net)],
        ["Đã thực thu", money(summary.paid)],
    ]

    return (
        <div className={`${styles.background} container-fluid report-page course-customer-report`}>
            <FilterReport
                startDate={startDate}
                endDate={endDate}
                handleRangeDate={(sDate, eDate) => {
                    setStartDate(sDate)
                    setEndDate(eDate)
                }}
                store={store}
                handleStore={setStore}
                title="Báo cáo Thu nợ"
                type="debt-collection"
                userAdmin={userAdmin}
            />
            <Spin spinning={loading}>
                <Row className="mb-3 align-items-center">
                    {metrics.map(([label, value], index) => (
                        <Col key={label} xs={6} md={4} lg={2} className="mb-2">
                            <div className={`course-kpi${index === 0 ? " is-primary" : ""}`}>
                                <div className="course-kpi-label">{label}</div>
                                <strong>{value}</strong>
                            </div>
                        </Col>
                    ))}
                    <Col xs={6} md={4} lg={2} className="mb-2">
                        <CSVLink data={csvData} filename={`thu-no-${startDate}-${endDate}.csv`} className="btn btn-primary btn-sm">
                            Xuất Excel
                        </CSVLink>
                    </Col>
                </Row>
                <div className="course-panel">
                    <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>
                        Danh sách KH chưa thanh toán hết dịch vụ từ 02 tháng trở lên
                    </div>
                    <div style={{ padding: "0 16px 8px", color: "#666", fontSize: 13 }}>
                        Tuổi nợ tính từ ngày tạo đơn. Khoảng ngày chỉ lọc theo ngày tạo đơn trong quá khứ; nếu chọn tháng hiện tại thì hiển thị toàn bộ nợ đủ 2 tháng.
                    </div>
                    <Table
                        className="course-grid"
                        columns={columns}
                        dataSource={details}
                        bordered
                        tableLayout="fixed"
                        scroll={{ x: 1400, y: 560 }}
                        pagination={{ pageSize: 50, showSizeChanger: false }}
                        locale={{ emptyText: "Không có đơn nợ trong bộ lọc này" }}
                    />
                </div>
            </Spin>
        </div>
    )
}

export default ReportDebtCollection
